import PropTypes from 'prop-types';

const OptionsIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 6a6 6 0 1 0 12 0 6 6 0 0 0-12 0zm0 18a6 6 0 1 0 12 0 6 6 0 0 0-12 0zm0 18a6 6 0 1 0 12 0 6 6 0 0 0-12 0z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  </div>
);

OptionsIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

OptionsIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default OptionsIcon;
